// src/components/VideoPlayer/VideoPlayer.js
import React from 'react';
import ReactPlayer from 'react-player';
import './NewVideoPlayer.css';

const VideoPlayer = ({ url }) => {
    return (
        <div className="player-wrapper">
            <ReactPlayer
                url={url}
                className="react-player"
                width="100%"
                height="100%"
                controls
                config={{
                    vimeo: {
                        playerOptions: {
                            dnt: true, // Do Not Track
                            controls: false, // Disable Vimeo's default controls
                            responsive: true,
                        }
                    },
                    file: {
                        attributes: {
                            controlsList: 'nodownload', // Disable download option for HTML5 videos
                            disablePictureInPicture: true // Disable Picture in Picture
                        }
                    }
                }}
            />
        </div>
    );
};

export default VideoPlayer;
